import { Space, Typography } from "antd";
import { Toggle } from "@libertify/ui";

type LabeledToggleProps = {
  toggleLabel?: string;
  // Injected by the parent Form.Item (valuePropName="checked").
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  loading?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
};

export const LabeledToggle = ({
  toggleLabel,
  checked,
  onChange,
  loading,
  disabled,
  ariaLabel,
}: LabeledToggleProps) => (
  <Space size={8} style={{ height: 40 }}>
    <Toggle
      size="l"
      checked={checked}
      onChange={onChange}
      loading={loading}
      disabled={disabled}
      aria-label={ariaLabel}
    />
    {toggleLabel && <Typography.Text strong>{toggleLabel}</Typography.Text>}
  </Space>
);
